import React from 'react';
// import PropTypes from 'prop-types';

const ProductPagination = ({ currentPage, totalPages, setCurrentPage }) => {
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const range = 2; // Nombre de pages à afficher de chaque côté de la page courante
    for (let i = Math.max(1, currentPage - range); i <= Math.min(totalPages, currentPage + range); i++) {
      pageNumbers.push(i);
    }
    return pageNumbers.map(number => (
      <li 
        key={number} 
        className={`page-item ${number === currentPage ? 'active' : ''}`}
      >
        <button 
          className="page-link" 
          onClick={() => handlePageChange(number)}
        >
          {number}
        </button>
      </li>
    ));
  };

  return (
    <nav aria-label="Page navigation">
      <ul className="pagination justify-content-center mt-4">
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button 
            className="page-link" 
            onClick={() => handlePageChange(currentPage - 1)}
            aria-disabled={currentPage === 1}
          >
            Previous
          </button>
        </li>
        {currentPage > 3 && (
          <>
            <li className="page-item">
              <button 
                className="page-link" 
                onClick={() => handlePageChange(1)}
              >
                1
              </button>
            </li>
            {currentPage > 4 && <li className="page-item disabled"><span className="page-link">...</span></li>}
          </>
        )}
        {renderPageNumbers()}
        {totalPages - currentPage > 2 && (
          <>
            {totalPages - currentPage > 3 && <li className="page-item disabled"><span className="page-link">...</span></li>}
            <li className="page-item">
              <button 
                className="page-link" 
                onClick={() => handlePageChange(totalPages)}
              >
                {totalPages}
              </button>
            </li>
          </>
        )}
        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <button 
            className="page-link" 
            onClick={() => handlePageChange(currentPage + 1)}
            aria-disabled={currentPage === totalPages}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

// // Définir les types de props attendus
// ProductPagination.propTypes = {
//   currentPage: PropTypes.number.isRequired,
//   totalPages: PropTypes.number.isRequired,
//   setCurrentPage: PropTypes.func.isRequired,
// };

export default ProductPagination;
